import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Group 2630" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        stroke: "currentColor",
        d: "M4.13 3.353a.49.49 0 0 1 .486.432v11.096l2.279-2.275.043-.038a.489.489 0 0 1 .689.683l-.041.046-3.456 3.456-3.456-3.456-.038-.043a.49.49 0 0 1 0-.6l.041-.046.043-.038a.49.49 0 0 1 .6 0l.046.041 2.277 2.277V3.842a.49.49 0 0 1 .432-.485Zm8.8-2.646 3.456 3.456.038.043a.49.49 0 0 1 0 .6l-.041.046-.043.038a.49.49 0 0 1-.6 0l-.046-.041-2.279-2.279v11.051a.49.49 0 0 1-.432.486h-.057a.49.49 0 0 1-.485-.432V2.579l-2.274 2.275-.043.038a.489.489 0 0 1-.689-.683l.041-.046Z",
        "data-name": "Path 1617"
      })
    ], -1)
  ])))
}
export default { render: render }